module.exports = __webpack_public_path__ + "img/code.3928638d.jpg";